import { Home, FileText, Calendar, MessageSquare, Plus, Search, Heart } from "lucide-react";
import { useAppContext } from "../lib/AppContext.tsx";
import { useLocation } from "wouter";

export default function BottomNavigation() {
  const { activeTab } = useAppContext();
  const [_, navigate] = useLocation();
  
  return (
    <div className="fixed bottom-3 left-0 right-0 max-w-md mx-auto px-4 pb-4 z-50">
      <div className="bg-white/80 backdrop-blur-sm shadow-xl border-0 rounded-2xl ring-0 outline-none shadow-[0_8px_30px_rgba(0,0,0,0.12)] flex justify-between items-center px-4 py-3">
        <button 
          className="flex flex-col items-center"
          onClick={() => navigate("/")}
        >
          <Home className={`h-6 w-6 ${activeTab === "home" ? "text-primary" : "text-gray-500"}`} />
          <span className={`text-xs mt-1 ${activeTab === "home" ? "text-primary font-medium" : "text-gray-500"}`}>
            Home
          </span>
        </button>
        
        <button 
          className="flex flex-col items-center" 
          onClick={() => navigate("/favorites")}
        >
          <Heart className={`h-6 w-6 ${activeTab === "favorites" ? "text-primary" : "text-gray-500"}`} />
          <span className={`text-xs mt-1 ${activeTab === "favorites" ? "text-primary font-medium" : "text-gray-500"}`}>
            Favorites
          </span>
        </button>

        {/* Centered blue search button */}
        <button
          className="flex items-center justify-center rounded-full bg-gradient-to-r from-blue-600 to-blue-400 shadow-lg w-12 h-12 -mt-6 border-4 border-white"
          onClick={() => navigate("/search")}
          aria-label="Search"
        >
          <Search className="h-7 w-7 text-white" />
        </button>
        
        <button 
          className="flex flex-col items-center"
          onClick={() => navigate("/schedule")}
        >
          <Calendar className={`h-6 w-6 ${activeTab === "schedule" ? "text-primary" : "text-gray-500"}`} />
          <span className={`text-xs mt-1 ${activeTab === "schedule" ? "text-primary font-medium" : "text-gray-500"}`}>
            Schedule
          </span>
        </button>
        
        <button 
          className="flex flex-col items-center"
          onClick={() => navigate("/messages")}
        >
          <MessageSquare className={`h-6 w-6 ${activeTab === "messages" ? "text-primary" : "text-gray-500"}`} />
          <span className={`text-xs mt-1 ${activeTab === "messages" ? "text-primary font-medium" : "text-gray-500"}`}>
            Messages
          </span>
        </button>
      </div>
    </div>
  );
}
